module.exports = __webpack_public_path__ + "static/krankheiten-7398d412662b1ffb414b52e4f8f5a2a8.jpg";